import { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom'; // custom code: useLocation
import { Form, Input } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
/* custom code start */
import qs from 'query-string';
import { Pluggable } from '@plone/volto/components/manage/Pluggable';
/* custom code end */

import { getNavroot } from '@plone/volto/actions/navroot/navroot';
import { hasApiExpander } from '@plone/volto/helpers/Utils/Utils';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import zoomSVG from '@plone/volto/icons/zoom.svg';

const messages = defineMessages({
  search: {
    id: 'Search',
    defaultMessage: 'Search',
  },
  searchSite: {
    id: 'Search Site',
    defaultMessage: 'Search Site',
  },
});

const SearchWidget = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  /* custom code start: the field starts with the current search term (#19373) */
  const location = useLocation();
  const [text, setText] = useState(
    () => qs.parse(location.search).SearchableText || '',
  );
  /* custom code end */
  const history = useHistory();
  const onChangeText = (event, { value }) => {
    setText(value);
  };
  const pathname = props.pathname;
  const onSubmit = (event) => {
    const path =
      pathname?.length > 0 ? `&path=${encodeURIComponent(pathname)}` : '';

    /* custom code start: our search view is registered at /search only and
       the field keeps the term after submitting (#19373) */
    history.push(`/search?SearchableText=${encodeURIComponent(text)}${path}`);
    /* custom code end */
    event.preventDefault();
  };

  /* custom code: the core reads the navigation root here only for the form
     address, which is a fixed path below, so there is no useSelector */
  useEffect(() => {
    if (!hasApiExpander('navroot', getBaseUrl(pathname))) {
      dispatch(getNavroot(getBaseUrl(pathname)));
    }
  }, [dispatch, pathname]);

  return (
    <>
      {/* custom code start: the same path as in onSubmit. The core builds it
          from the navigation root, which is the internal backend address
          when the page is rendered on the server */}
      <Form action="/search" onSubmit={onSubmit}>
        {/* custom code end */}
        <Form.Field className="searchbox">
          {/* custom code start: the button sits in front of the input (#19259) */}
          <button aria-label={intl.formatMessage(messages.search)}>
            <Icon name={zoomSVG} size="18px" />
          </button>
          {/* custom code end */}
          <Input
            aria-label={intl.formatMessage(messages.search)}
            onChange={onChangeText}
            name="SearchableText"
            value={text}
            transparent
            autoComplete="off"
            placeholder={intl.formatMessage(messages.searchSite)}
            title={intl.formatMessage(messages.search)}
          />
        </Form.Field>
      </Form>
      {/* custom code start: the search view plugs its collection filter here (#19383) */}
      <Pluggable name="horn.next.searchwidget" />
      {/* custom code end */}
    </>
  );
};

export default SearchWidget;
